import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { highlights } from '../data/mock';

const HighlightsSection = () => {
  return (
    <section className="py-16 sm:py-24 bg-[#0d1f35]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 sm:gap-16 items-center">
          {/* Image Side */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl shadow-black/40">
              <img
                src="https://embassyverde.com/images/Mask-Group-8.png"
                alt="Embassy Verde Elevation"
                className="w-full h-[300px] sm:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628]/60 to-transparent" />
            </div>
            {/* Floating Card */}
            <div className="absolute -bottom-4 sm:-bottom-8 -right-4 sm:-right-8 bg-gradient-to-br from-[#c9a961] to-[#8b7355] rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-xl">
              <p className="text-[#0a1628] font-bold text-xl sm:text-3xl">280</p>
              <p className="text-[#0a1628]/80 text-xs sm:text-sm font-medium">Acres Township</p>
            </div>
          </div>

          {/* Content Side */}
          <div className="order-1 lg:order-2">
            <span className="text-[#c9a961] text-xs sm:text-sm font-semibold tracking-widest uppercase">Why Choose Us</span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mt-2 sm:mt-3 mb-6 sm:mb-8">Project Highlights</h2>
            
            <div className="space-y-4 sm:space-y-5">
              {highlights.map((highlight, index) => (
                <div key={index} className="flex items-start gap-3 sm:gap-4 group">
                  <div className="flex-shrink-0 w-6 h-6 sm:w-8 sm:h-8 bg-[#c9a961]/20 rounded-full flex items-center justify-center">
                    <CheckCircle2 className="w-4 h-4 sm:w-5 sm:h-5 text-[#c9a961]" />
                  </div>
                  <p className="text-white/80 text-sm sm:text-lg leading-relaxed">
                    {highlight}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HighlightsSection;
